import { createSlice } from "@reduxjs/toolkit";
import Client from "../../model/Client";
import { createClient, getClients, resetUpdateSuccess, updateClient, deleteClient, resetDeleteSuccess, resetCreateFailure} from "../actions/clientActions";



interface ClientState {
    loadingQuery: boolean;
    creatingClient: boolean;
    updatingClient: boolean;
    deletingClient: boolean;
    deleteSuccess: boolean;
    saveSuccess: boolean;
    createFailed: boolean;
    clients : Client[];
}

const initialState: ClientState = {
    loadingQuery: false,
    creatingClient: false,
    updatingClient: false,
    deletingClient: false,
    deleteSuccess: false,
    saveSuccess: false,
    createFailed: false,
    clients: []    
}


const clientSlice = createSlice({
    name: 'client',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getClients.pending, (state)  => {
            state.loadingQuery = true;
        });

        builder.addCase(getClients.rejected, (state) => {
            state.loadingQuery = false;
        });

        builder.addCase(getClients.fulfilled, (state, action) => {
            state.loadingQuery = false;
            state.clients = action.payload.clients;
        });

        builder.addCase(createClient.pending, (state) => {
            state.creatingClient = true
        });
        
        builder.addCase(createClient.rejected, (state) => {
            state.creatingClient = false
            state.createFailed = true;
        });        

        builder.addCase(createClient.fulfilled, (state) => {
            state.creatingClient = false
            state.saveSuccess = true;
        });

        builder.addCase(resetCreateFailure, (state) => {
            state.createFailed = false;
        });

        builder.addCase(updateClient.pending, (state) => {
            state.updatingClient = true
        });
        
        builder.addCase(updateClient.rejected, (state) => {
            state.updatingClient = false
        });

        builder.addCase(updateClient.fulfilled, (state) => {
            state.updatingClient = false
            state.saveSuccess = true;
        });
        
        builder.addCase(resetUpdateSuccess, (state) => {
            state.saveSuccess = false;
        });

        builder.addCase(deleteClient.pending, (state) => {
            state.deletingClient = true
        });
        
        builder.addCase(deleteClient.rejected, (state) => {
            state.deletingClient = false
        });

        builder.addCase(deleteClient.fulfilled, (state, action) => {            
            state.deletingClient = false
            state.deleteSuccess = true;
        });

        builder.addCase(resetDeleteSuccess, (state) => {
            state.deleteSuccess = false;
        });
    }
});

export default clientSlice.reducer;